
import Vue from 'vue';

import MenuIcon from 'vue-material-design-icons/Menu.vue';
import SearchIcon from 'vue-material-design-icons/Magnify.vue';
import HomeIcon from 'vue-material-design-icons/HomeOutline.vue';
import ExitToApp from 'vue-material-design-icons/ExitToApp.vue';
import CalendarToday from 'vue-material-design-icons/CalendarToday.vue';
import SupervisorAccount from 'vue-material-design-icons/AccountSupervisor.vue';
import Plus from 'vue-material-design-icons/Plus.vue';
import TrashCan from 'vue-material-design-icons/TrashCan.vue';
import Pencil from 'vue-material-design-icons/Pencil.vue';
import Check from 'vue-material-design-icons/Check.vue';
import GoBack from 'vue-material-design-icons/UndoVariant.vue';

import teste from 'vue-material-design-icons/Magnify.vue';
Vue.component('teste-icon', teste);

Vue.component('search-icon', SearchIcon);
Vue.component('menu-icon', MenuIcon);
Vue.component('home-icon', HomeIcon);
Vue.component('exit-icon', ExitToApp);
Vue.component('calendar-icon', CalendarToday);
Vue.component('supervisor-account-icon', SupervisorAccount);
Vue.component('plus-icon', Plus);
Vue.component('trash-icon', TrashCan);
Vue.component('pencil-icon', Pencil);
Vue.component('check-icon', Check);
Vue.component('go-back-icon', GoBack);
